!function ($, window, undefined) {
    if (window.golfbox === undefined)
        window.golfbox = window.gb = {};

    var document = window.document,
        navigator = window.navigator,
        location = window.location,
        _ = window.golfbox;

    function isEmbedded() {
        try {
            return window.self !== window.top;
        } catch (e) { // CORS exception which means it is based in a different domain, ie. iFrame.
            return true;
        }
    }
    window.isEmbedded = isEmbedded();

    let displayChildrenFilter = function (i, e) {
        return e.tagName.toLowerCase() !== 'link' &&
            e.tagName.toLowerCase() !== 'script' &&
            $(e).css('position') !== 'fixed';
    };

    let maxXfilter = function (e) {
        return (parseFloat($(e).css('margin-bottom')) || 0) + e.offsetTop + e.scrollHeight;
    };

    _.iframeResize = function () {
        if (isEmbedded) {
            let $overflow_content = null,
                newHeight = null,
                lastHeight = null,
                currentHeight = null,
                $children = null;

            $(window).on('documentResize', function () {
                window.parent.postMessage(newHeight + 'px@' + window.name, "*");
                gb.logging.log('resized', 'iFrame');
            }).on('load', function () {
                if (window.parent !== window) {
                    $overflow_content = $('.overflow-content');
                    $children = $overflow_content.children().filter(displayChildrenFilter);
                    setInterval(function () {
                        currentHeight = $children.toArray().max(maxXfilter);
                        if (lastHeight !== currentHeight) {
                            newHeight = lastHeight = currentHeight;
                            $(window).trigger('documentResize');
                        }
                    }, 100);
                }
            });
        }
    };

    _.isTouch = function () {
        return /(iphone|ipod|ipad|android|iemobile|blackberry|bada)/.test(window.navigator.userAgent.toLowerCase());
    };

    _.isDragAndDropSupported = () => {
        var div = document.createElement('div');
        return ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
    };

    _.doLogin = function (loginUrl, callback) {
        if (window.isEmbedded) {
            let login_window_func = function () {
                // Storage access was granted.
                let login_window = window.open(loginUrl, '_blank', 'height=600,width=350');
                let login_window_closed = setInterval(() => {
                    if (login_window.closed) {
                        clearInterval(login_window_closed);
                        if (callback) {
                            console.log('callback: ' + callback);
                            callback();
                        } else {
                            window.location.replace(window.location.pathname + ((q) => {
                                let qs = [];
                                if (q) {
                                    qs = q.replace('?', '').split('&');
                                }
                                qs[qs.length] = 'd=' + +(new Date());
                                return '?' + qs.join('&');
                            })(window.location.search) + window.location.hash);
                        }
                    }
                }, 100);
            };

            if (document.requestStorageAccess) {
                document
                    .requestStorageAccess()
                    .then(
                        login_window_func,
                        function () {
                            // Storage access was denied.
                            alert('access to cookies wasn\'t granted. We are unable to authenticate you.');
                        }
                    );
            } else {
                login_window_func();
            }
            
        } else {
            location.href = loginUrl;
        }
    };

    _.doLogout = function (logoutUrl) {
        if (window.isEmbedded) {
            let logout_window_func = function () {
                // Storage access was granted.
                let login_window = window.open('/LogOutIFrame', '_blank', 'height=250,width=500');
                let login_window_closed = setInterval(() => {
                    if (login_window.closed) {
                        clearInterval(login_window_closed);
                        window.location.replace(window.location.pathname + ((q) => {
                            let qs = [];
                            if (q) {
                                qs = q.replace('?', '').split('&');
                            }
                            qs[qs.length] = 'd=' + +(new Date());
                            return '?' + qs.join('&');
                        })(window.location.search) + window.location.hash);
                    }
                }, 100);
            };
            if (document.requestStorageAccess) {
                document
                    .requestStorageAccess()
                    .then(
                        logout_window_func,
                        function () {
                            // Storage access was denied.
                            alert('access to cookies wasn\'t granted. We are unable to log you out.');
                        }
                    );
            } else {
                logout_window_func();
            }
        } else {
            location.href = logoutUrl;
        }
    };

    // https://stackoverflow.com/questions/10730362/get-cookie-by-name
    _.getCookie = function (name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length === 2) {
            return parts.pop().split(";").shift();
        } else {
            return '';
        }
    };
    _.setCookie = function (cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    _.defer = function(func, depend, id) {
        if (func && typeof func === 'function') {
            id && console.log(`defer@start: ${id}`);
            let dependFunc = depend instanceof Array ? dependArray : dependSingle;
            window.addEventListener('load', () => {
                setTimeout(() => {
                    if (depend) {
                        dependFunc(depend, func, id);
                    } else {
                        func();
                        id && console.log(`defer@exec: ${id}`);
                    }
                }, 10);
            });
        }
    };

    let dependSingle = (obj, func, id) => {
        if (!obj) {
            setTimeout(() => { dependSingle(obj, func, id); }, 50);
        } else {
            func();
            id && console.log(`defer@exec: ${id}`);
        }
    };

    let dependArray = (obj, func, id) => {
        let success = true;
        for (let key in obj) {
            if (!obj[key]) {
                setTimeout(() => { dependArray(obj, func, id); }, 100);
                success = false;
                break;
            }
        }

        success && func();
        id && console.log(`defer@exec: ${id}`);
    };
}(jQuery, window);